import { render, staticRenderFns } from "./storeroom.vue?vue&type=template&id=b5e1adb4&"
import script from "./storeroom.vue?vue&type=script&lang=js&"
export * from "./storeroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports